import { useCallback } from "react"
import { useProdutoApi } from "../../infra/produto"
import { useAppDispatch, useAppSelector } from "../../presentation/hooks/store-hooks"
import { setCurrentUserModulesState } from "../../application/states/user"
import { useLocalStorageService } from "../local-storage"
import { useUIService } from "../ui"

export const useProdutoService = () => {
  const dispatch = useAppDispatch()
  const currentUser = useAppSelector((state) => state.user.currentUser)
  const { getProdutosByIdUsuarioApi } = useProdutoApi()
  const { setLoading } = useUIService()
  const { setItem } = useLocalStorageService()

  const getProdutosByIdUsuarioAndSetModules = useCallback(async () => {
    if (currentUser && currentUser.IdUsuario) {
      const loadingId = Math.random().toString()
      try {
        setLoading({
          id: loadingId,
          loading: true,
          message: 'Buscando módulos do usuário...'
        })

        const produtos = await getProdutosByIdUsuarioApi({
          IdUsuario: currentUser.IdUsuario
        })

        const moduleInfo = produtos.map((produto) => {
          return {
            IdProduto: produto.IdProduto,
            Nome: produto.Descricao
          }
        })

        setItem({
          key: 'USER_MODULES',
          value: JSON.stringify(moduleInfo)
        })

        dispatch(setCurrentUserModulesState(moduleInfo))
      } catch (error: any) {
        console.error("Erro ao buscar produtos do usuário:", error)
      } finally {
        setLoading({
          id: loadingId,
          loading: false
        })
      }
    }
  }, [currentUser, dispatch, getProdutosByIdUsuarioApi, setLoading, setItem])

  return {
    getProdutosByIdUsuarioAndSetModules
  }
}
